export const environment = {
  production: false,
  apiURL: 'https://api.hanadiv.org/admin',
};
